import AdminLayout from '../../components/dashboard/admin/AdminLayout';
import PaymentManagement from '../../components/admin/payments/PaymentManagement';

const AdminPayments = () => {
  return (
    <AdminLayout>
      <PaymentManagement />
    </AdminLayout>
  );
};

export default AdminPayments;